import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import UnitBar from "../../components/property/unit/UnitBar";
import UnitCard from "../../components/property/unit/UnitCard";
import BoxContainer from "../../containers/shared/BoxContainer";
import Button from "../../components/shared/Button";
import PropertyBar from "../../components/property/PropertyBar";
import PropertyCard from "../../components/property/PropertyCard";
import { useAppLatyoutContext } from "../../layouts/appLayout";
import useUser from "../../components/helpers/useUser";
import Loading from "../../components/shared/Loading";
import Pagination from "../../components/shared/Pagination";
import NoHeadBoxContainer from "../../containers/shared/NoHeadBoxContainer";
import DetailsBar from "../../components/wallet/DetailsBar";
import DetailsCard from "../../components/wallet/DetailsCard";
import SingleDetailBar from "../../components/wallet/SingleDetailBar";
import SingleDetailCard from "../../components/wallet/SingleDetailCard";
import { UserContext } from "../../App";

const WalletSingleDetailPage = () => {

    const appLatyoutContext = useAppLatyoutContext();
    const [isLoading, setIsLoading] = useState(true);

    const [user, setUser] = useUser();

    const { fields } = useContext(UserContext);

    const [subPropertiesPageSize, setSubPropertiesPageSize] = useState(20);
    const [currentSubPropertiesPage,setCurrentSubPropertiesPage] = useState(1);
    const [totalSubProperties,setTotalSubProperties] = useState(0);
    const [currentSubPropertiesCount,setCurrentSubPropertiesCount] = useState(0);
    const [hasMoreSubProperties,setHasMoreSubProperties] = useState(true);
    const [isSubPropertiesEmpty, setIsSubPropertiesEmpty] = useState(true);

    const [unitsPageSize, setUnitsPageSize] = useState(20);
    const [currentUnitsPage,setCurrentUnitsPage] = useState(1);
    const [totalUnits,setTotalUnits] = useState(0);
    const [currentUnitsCount,setCurrentUnitsCount] = useState(0);
    const [hasMoreUnits,setHasMoreUnits] = useState(true);
    const [isUnitsEmpty, setIsUnitsEmpty] = useState(true);

    const {t,i18n} = useTranslation();
    const { id } = useParams();
    const [property, setProperty] = useState(null);
    const [units, setUnits] = useState(null);
    const [subProperties, setSubProperties] = useState(null);
    useDocumentTitle('تفاصيل رصيد الوحدات');
    const navigate = useNavigate();
    const pageTitle = {title: 'تفاصيل رصيد الوحدات', subTitle: 'يمكنك متابعة مصروفاتك وفواتيرك وشحن رصيد المحفظة' };
    const [parentPropertyType, setParentPropertyType] = useState(null);

    const [searchParams] = useSearchParams();
    const querySearch = searchParams.get('search') || "";

    useEffect(() => {
      if (querySearch.length > 0 && querySearch.length < 3) {
        return;
      }

      const delayDebounceFn = setTimeout(() => {
        if(property?.propertyType?.allowSubProperty) {
          getSubProperties(1, querySearch);
        }
        if(units) {
          getUnits(1, querySearch);
        }
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }, [querySearch]);


    
    const getProperty = async () => {
      try {
        const response = await apiClient.get(`/b-properties/${id}`);
        if(response?.data) {
          setIsLoading(false);
          setProperty(response?.data);
          // setUnits(response?.data?.units);
          setParentPropertyType(response?.data?.propertyType);
          if(response?.data?.subProperties) {
            setSubProperties(response?.data?.subProperties);
          }
        } else {

        }
      } catch(err) {}
    }

    const getUnits = async (page=1, searchTerm = "") => {

      let url = `/b-units?business=${user?.business?._id ? user?.business._id : user?.business}&propertyId=${id}&skip=${(page-1)*unitsPageSize}&limit=${unitsPageSize}`;
      
      if (searchTerm && searchTerm.length >= 3) {
        url += `&name=${encodeURIComponent(searchTerm)}`;
      }

      try {
        const response = await apiClient.get(url);
        if(response?.data) {
          setUnits(response?.data);
          setTotalUnits(response?.data?.length);

          if(response?.data?.length > 0) {
            setIsUnitsEmpty(false);
            setCurrentUnitsCount(response?.data?.length);
            setCurrentUnitsPage(page);
            if(response?.data?.length === pageSize) {
              setHasMoreUnits(true);
            }
          } else {
              setHasMoreUnits(false);
          }
        } else {

        }
      } catch(err) {}
    }

    const getSubProperties = async (page=1, searchTerm = "") => {

      let url = `/b-properties?parentId=${id}&skip=${(page-1)*subPropertiesPageSize}&limit=${subPropertiesPageSize}`;
      
      if (searchTerm && searchTerm.length >= 3) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }


      try {
        const response = await apiClient.get(url);
        if(response?.data) {
          setTotalSubProperties(response?.data?.numberOfAllProperties);
          setSubProperties(response?.data?.properties);
          if(response?.data?.properties?.length > 0) {
            setIsSubPropertiesEmpty(false);
            setCurrentSubPropertiesCount(response?.data?.properties?.length);
            setCurrentSubPropertiesPage(page);
            if(response?.data?.properties?.length === pageSize) {
              setHasMoreSubProperties(true);
            }
          } else {
              setHasMoreSubProperties(false);
          }
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
      if(id) {
        getProperty();
      }
    },[id])
    
    useEffect(()=>{
      if(property?._id) {
        if(property?.propertyType?.allowSubProperty) {
          getSubProperties();
        } else {
          getUnits();
        }
      }
    },[property])

    const handleClickUnitCard = (UnitId) => {
      navigate(`/ar/unit/${UnitId}`);
    }

    const handleClickEditUnit = () => {
      navigate(`/ar/property/edit/${id}`);
    }

    const handleClickPropertyCard = (id) => {
      navigate(`/ar/property/${id}`);
    }

    const getNumberOfSubRequests = (units) => {
      let numberOfSubRequests = 0;
      units?.map(unit=>{
        numberOfSubRequests = numberOfSubRequests + unit?.numberOfSubRequests;
      })
      return numberOfSubRequests;
    }

    const handleChangePageSubPropertiesAction = (page) => {
      getSubProperties(page);
    }

    const subPropertyDisplayName = property?.propertyType?.category === 'commercial' 
                                   ? appLatyoutContext?.propertyTypes?.commercial?.find(subProperty => subProperty?._id === property?.propertyType?._id)?.children[0]?.name
                                   : appLatyoutContext?.propertyTypes?.residential?.find(subProperty => subProperty?._id === property?.propertyType?._id)?.children[0]?.name;
    const subPropertyUnitDisplayName = property?.propertyType?.category === 'commercial' 
                                   ? appLatyoutContext?.propertyTypes?.commercial?.find(subProperty => subProperty?._id === property?.propertyType?._id)?.children[0]?.unitDisplayName
                                   : appLatyoutContext?.propertyTypes?.residential?.find(subProperty => subProperty?._id === property?.propertyType?._id)?.children[0]?.unitDisplayName;

                    
    const totalTransactions = property?.units && property?.units?.reduce((total, currentObject) => {
    const amount = currentObject.unitOrdersLogs?.length || 0;
    
    return total + amount;
    }, 0);

    const totalRemainingAmount = property?.units && property?.units?.reduce((total, currentObject) => {
    const amount = currentObject.spendingLimitConfig?.remainingAmount || 0;
    
    return total + amount;
    }, 0);

  return (
    <>
        <div>
        <PageHeader pageTitle={pageTitle} white />
        <PageMain>
            <div className="fixed top-0 left-0 w-full h-full bg-grey-50 z-[-1]"></div>
            <MainContent noMargin={true}>
            <NoHeadBoxContainer propertyDetails={false} editText={'تعديل بيانات المنشأة'} propertyEditLink={`/ar/property/edit/${id}`}>
                    <div className="flex flex-nowrap justify-between self-stretch items-center gap-x-[16px] pb-[24px] mb-[24px] border-b-[1px] border-b-grey-300">
                        <div className="max-w-[70%]">
                            <h2 className="text-[24px] text-grey-900 font-[700] leading-[36px] mb-[5px]">{property?.name && property?.name}</h2>
                            {!property?.parentId && <p className="text-[13px] text-grey-950 font-[500] leading-[20px] whitespace-nowrap truncate overflow-hidden">{property?.description && property?.description}</p>}
                        </div>
                        <div>
                            <div className="w-[324px]">
                                {/* <Button text={'تعديل بيانات الوحدة'} bgColor={'!bg-grey-800'} onClick={()=>handleClickEditUnit()} /> */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="bg-grey-50 rounded-[8px] px-[16px] py-[8px] text-grey-600 mb-[24px]">
                        <h4 className="mb-[4px] text-[24px] font-[500]">{property?.addressDetails?.addressLine || 'مثال لعنوان للوحدة يمكن تغييره في وقت لاحق'}</h4>
                        <p className="text-[14px] font-[500]"><span className="inline-block align-middle w-[16px] h-[16px] me-[4px] !bg-center !bg-no-repeat brightness-50" style={{background:"url('/assets/images/location.svg')", backgroundSize: "16px"}}></span> العنوان التفصيلي</p>
                    </div> */}
                    <div className="h-[61px] flex flex-nowrap">
                        <div className="text-[24px] font-[500] text-grey-900 whitespace-nowrap">
                            {totalRemainingAmount?.toLocaleString()}
                            <svg width="16" height="15" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle ms-[4px]">
                                <g clipPath="url(#clip0_5628_42783)">
                                    <path d="M6.84841 10.6314C6.65212 11.0563 6.52237 11.5173 6.47266 12.0008L10.6266 11.1389C10.8229 10.7141 10.9525 10.253 11.0024 9.76953L6.84841 10.6314Z" className="fill-grey-900" />
                                    <path d="M10.6242 8.55594C10.8205 8.1312 10.9503 7.67007 11 7.18659L7.76421 7.85833V6.56701L10.6241 5.97378C10.8204 5.54904 10.9502 5.08791 10.9999 4.60443L7.76411 5.27559V0.631619C7.26829 0.90335 6.82796 1.26505 6.47001 1.6917V5.54417L5.17591 5.81265V0C4.68009 0.271635 4.23976 0.633434 3.88181 1.06008V6.08104L0.986256 6.68162C0.789964 7.10636 0.660114 7.56749 0.610307 8.05097L3.88181 7.37236V8.99854L0.375754 9.72577C0.179462 10.1505 0.0497091 10.6116 0 11.0951L3.66986 10.3339C3.96861 10.2732 4.22537 10.1008 4.39231 9.86359L5.06534 8.88966V8.88947C5.13521 8.7887 5.17591 8.66721 5.17591 8.53636V7.10388L6.47001 6.83539V9.41803L10.6241 8.55575L10.6242 8.55594Z" className="fill-grey-900" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_5628_42783">
                                        <rect width="11" height="12" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <span className="block mt-[4px] font-[500] text-[14px] text-grey-600" onClick={()=>setShowUnitDetails(true)}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle me-[4px]">
                                    <path d="M11.8267 15.1665H4.17335C2.51335 15.1665 1.16669 13.8198 1.16669 12.1598V7.67318C1.16669 6.01318 2.51335 4.6665 4.17335 4.6665H11.8267C13.4867 4.6665 14.8334 6.01318 14.8334 7.67318V8.63318C14.8334 8.90651 14.6067 9.13318 14.3334 9.13318H12.9867C12.7534 9.13318 12.54 9.21984 12.3867 9.37984L12.38 9.38652C12.1934 9.56652 12.1067 9.81315 12.1267 10.0665C12.1667 10.5065 12.5867 10.8598 13.0667 10.8598H14.3334C14.6067 10.8598 14.8334 11.0865 14.8334 11.3598V12.1532C14.8334 13.8198 13.4867 15.1665 11.8267 15.1665ZM4.17335 5.6665C3.06669 5.6665 2.16669 6.56651 2.16669 7.67318V12.1598C2.16669 13.2665 3.06669 14.1665 4.17335 14.1665H11.8267C12.9334 14.1665 13.8334 13.2665 13.8334 12.1598V11.8665H13.0667C12.06 11.8665 11.2067 11.1198 11.1267 10.1598C11.0734 9.61316 11.2734 9.07318 11.6734 8.67985C12.02 8.32652 12.4867 8.13318 12.9867 8.13318H13.8334V7.67318C13.8334 6.56651 12.9334 5.6665 11.8267 5.6665H4.17335Z" fill="#475569"/>
                                    <path d="M1.66669 8.7735C1.39335 8.7735 1.16669 8.54683 1.16669 8.2735V5.22687C1.16669 4.23354 1.79335 3.3335 2.72002 2.98017L8.01335 0.980166C8.56002 0.7735 9.16669 0.846865 9.64002 1.1802C10.12 1.51353 10.4 2.05353 10.4 2.63353V5.16685C10.4 5.44019 10.1734 5.66685 9.90002 5.66685C9.62669 5.66685 9.40002 5.44019 9.40002 5.16685V2.63353C9.40002 2.38019 9.28002 2.14685 9.06669 2.00019C8.85335 1.85352 8.60002 1.82018 8.36002 1.91352L3.06669 3.91352C2.52669 4.12018 2.16002 4.64687 2.16002 5.22687V8.2735C2.16669 8.5535 1.94002 8.7735 1.66669 8.7735Z" fill="#475569"/>
                                    <path d="M13.0666 11.8666C12.06 11.8666 11.2066 11.12 11.1266 10.16C11.0733 9.60662 11.2733 9.06663 11.6733 8.6733C12.0133 8.32663 12.48 8.1333 12.98 8.1333H14.3666C15.0266 8.1533 15.5333 8.67327 15.5333 9.31327V10.6866C15.5333 11.3266 15.0266 11.8466 14.3866 11.8666H13.0666ZM14.3533 9.1333H12.9866C12.7533 9.1333 12.54 9.21996 12.3866 9.37996C12.1933 9.56663 12.1 9.81995 12.1266 10.0733C12.1666 10.5133 12.5866 10.8666 13.0666 10.8666H14.3733C14.46 10.8666 14.54 10.7866 14.54 10.6866V9.31327C14.54 9.21327 14.46 9.13997 14.3533 9.1333Z" fill="#475569"/>
                                    <path d="M9.33335 8.5H4.66669C4.39335 8.5 4.16669 8.27333 4.16669 8C4.16669 7.72667 4.39335 7.5 4.66669 7.5H9.33335C9.60669 7.5 9.83335 7.72667 9.83335 8C9.83335 8.27333 9.60669 8.5 9.33335 8.5Z" fill="#475569"/>
                                </svg>
                                رصيد المحفظة
                            </span>
                        </div>
                        <div className="relative w-[193px] h-[61px]"><span className="block w-[1px] h-[40px] bg-grey-300 absolute top-[10px] left-[96px]"></span></div>
                        {property?.propertyType?.allowSubProperty && <><div className="text-[25px] font-[600] text-grey-900">
                          {property?.subProperties?.length || 0}
                            <span className="block mt-[4px] font-[500] text-[14px] text-grey-600">
                                <span className="w-[16px] h-[16px] inline-block align-middle !bg-center !bg-no-repeat me-[4px]" style={{background: "url('/assets/images/buildings.svg')"}}></span>
                                { subPropertyDisplayName ? subPropertyDisplayName : 'عدد المنشآت الفرعية'}
                            </span>
                        </div>
                        <div className="relative w-[193px] h-[61px]"><span className="block w-[1px] h-[40px] bg-grey-300 absolute top-[10px] left-[96px]"></span></div></>}
                        <div className="text-[25px] font-[600] text-grey-900">
                            {property?.numberOfUnits || 0}
                            <span className="block mt-[4px] font-[500] text-[14px] text-grey-600">
                                <span className="w-[16px] h-[16px] inline-block align-middle !bg-center !bg-no-repeat me-[4px] brightness-50" style={{background: "url('/assets/images/building.svg')"}}></span>
                                { property?.subProperties?.length > 0 ? subPropertyUnitDisplayName ? subPropertyUnitDisplayName : 'عدد الوحدات' : property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'عدد الوحدات' }
                            </span>
                        </div>
                        { !property?.parentId && <><div className="relative w-[193px] h-[61px]"><span className="block w-[1px] h-[40px] bg-grey-300 absolute top-[10px] left-[96px]"></span></div> 
                        <div className="text-[25px] font-[600] text-grey-900">
                            {totalTransactions || 0}
                            <span className="block mt-[4px] font-[500] text-[14px] text-grey-600">
                                <span className="w-[16px] h-[16px] inline-block align-middle !bg-center !bg-no-repeat me-[4px] brightness-50" style={{background: "url('/assets/images/note.svg')"}}></span>
                                عدد المعاملات
                            </span>
                        </div></>}
                    </div>
                </NoHeadBoxContainer>
              {property?.propertyType?.allowSubProperty ?
              <>
              <div className="pt-[25px] px-[15px]">
                <DetailsBar propertiesCount={property?.unitsCount || 0} propertyLabel={`${subPropertyDisplayName ? subPropertyDisplayName : 'منشأة فرعية'}`} subProperty={true} addSubPropertyLink={`/ar/property/addSubProperty/${id}`} ButtonLabel={`إضافة ${subPropertyDisplayName ? subPropertyDisplayName : 'منشأة فرعية'}`} />
                {subProperties === null && <Loading  showLoading={true} />}
                {subProperties !== null && Array.isArray(subProperties) && subProperties?.length < 1 && querySearch && 
                <div className="pt-[80px] text-center">
                  <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/main-property-icon.svg')"}}></div>
                  <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لاتوجد {`${subPropertyDisplayName ? subPropertyDisplayName : 'منشأة فرعية'}`} مطابقة لكلمة البحث</div>
                  {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to={`/ar/property/addSubProperty/${id}`}>{`إضافة ${subPropertyDisplayName ? subPropertyDisplayName : 'منشأة فرعية'}`}</Link> */}
                </div> }
                {subProperties !== null && Array.isArray(subProperties) && subProperties?.length < 1 && !querySearch && !isSubPropertiesEmpty && <Loading showLoading={true} />}
                {subProperties !== null && Array.isArray(subProperties) && subProperties?.length < 1 && !querySearch && isSubPropertiesEmpty &&
                <div className="pt-[80px] text-center">
                  <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/main-property-icon.svg')"}}></div>
                  <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لم تقم بإضافة أي {`${subPropertyDisplayName ? subPropertyDisplayName : 'منشأة فرعية'}`} حتي الأن</div>
                  {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to={`/ar/property/addSubProperty/${id}`}>{`إضافة ${subPropertyDisplayName ? subPropertyDisplayName : 'منشأة فرعية'}`}</Link> */}
                </div> }
                {subProperties !== null && Array.isArray(subProperties) && subProperties?.length > 0 && 
                <div className="pt-[25px] flex  gap-[32px] flex-wrap pb-[83px] relative">
                  {subProperties?.map(((property,index)=>{
                    return <DetailsCard key={`property-${index}`} 
                                        parentType={parentPropertyType}
                                        image={property?.files?.length > 0 && property?.files[0]} 
                                        name={property?.name} 
                                        description={property?.description} 
                                        units={property?.numberOfUnits} 
                                        unitsData={property?.units}
                                        propertyType={property?.propertyType} 
                                        showDescription={false}
                                        requests={property?.requests?.length} 
                                        subProperties={property?.subProperties}
                                        commercialData={appLatyoutContext?.propertyTypes?.commercial}
                                        residentialData={appLatyoutContext?.propertyTypes?.residential}
                                        onClick={()=>handleClickPropertyCard(property?._id)} />
                  }))}
                  <div className="w-full absolute bottom-0 left-0">
                    <Pagination label={subPropertyDisplayName ? subPropertyDisplayName : 'منشآت'} total={totalSubProperties} currentCount={currentSubPropertiesCount} currentPage={currentSubPropertiesPage} pageSize={subPropertiesPageSize} handleClickChangePage={page => handleChangePageSubPropertiesAction(page)} hasMore={hasMoreSubProperties} />
                  </div>
                </div> }
              </div>
              </>
            :
            <>
            <div className="pt-[25px] px-[15px]">
            <SingleDetailBar unitsCount={property?.numberOfUnits} unitLabel={`${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'وحدة'}`} ButtonLink={`/ar/property/${id}/addUnit`} ButtonLabel={`إضافة ${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'وحدة'}`} />
            {units === null && <Loading showLoading={true} />}
            {units !== null && Array.isArray(units) && units?.length < 1 && querySearch &&
                <div className="pt-[80px] text-center">
                  <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/main-property-icon.svg')"}}></div>
                  <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لاتوجد  {`${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'وحدة'}`} مطابقة لكلمة البحث</div>
                  {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to={`/ar/property/${id}/addUnit`}>{`إضافة ${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'وحدة'}`}</Link> */}
                </div> }
            {units !== null && Array.isArray(units) && units?.length < 1 && !querySearch && !isUnitsEmpty && <Loading showLoading={true} />}
            {units !== null && Array.isArray(units) && units?.length < 1 && !querySearch && isUnitsEmpty &&
                <div className="pt-[80px] text-center">
                  <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/main-property-icon.svg')"}}></div>
                  <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لم تقم بإضافة أي {`${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'وحدة'}`} حتي الأن</div>
                  {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to={`/ar/property/${id}/addUnit`}>{`إضافة ${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'وحدة'}`}</Link> */}
                </div> }
            {units !== null && Array.isArray(units) && units?.length > 0 && 
              <div className="pt-[25px] flex gap-[32px] flex-wrap pb-[83px] relative">
                {units?.map(((unit,index)=>{
                  return <SingleDetailCard key={`property-${index}`} fields={fields} unitData={unit} name={unit?.name} city={unit?.addressDetails?.city} requests={unit?.numberOfSubRequests} deleted={unit?.deletedAt || false} onClick={()=>handleClickUnitCard(unit?._id)} />
                }))}
                {/* <div className="w-full absolute bottom-0 left-0">
                  <Pagination label={'وحدات'} total={totalUnits} currentCount={currentUnitsCount} currentPage={currentUnitsPage} pageSize={unitsPageSize} handleClickChangePage={page => handleChangePageUnitsAction(page)} hasMore={hasMoreUnits} />
                </div> */}
              </div>}
              </div>
            </>}
            </MainContent>
        </PageMain>
        </div>

        <Loading showLoading={isLoading} />
    </>
  );
};

export default WalletSingleDetailPage;
